export type BriefingSignal = {
  id: string
  label: string
  count: number
  tone: 'action' | 'neutral' | 'warn'
}

// The three counts the briefing paragraph refers to, surfaced as jump targets.
export const briefingSignals: BriefingSignal[] = [
  { id: 'approvals', label: 'Need approval', count: 3, tone: 'action' },
  { id: 'projects', label: 'Active projects', count: 4, tone: 'neutral' },
  { id: 'attention', label: 'Campaigns need attention', count: 2, tone: 'warn' },
]

export type RailTask = {
  id: string
  title: string
  owner: string
  due: string
  kind: 'approval' | 'launch' | 'review'
}

export const railTasks: RailTask[] = [
  { id: 't1', title: 'Approve Montce Meta creative', owner: 'Carolyn', due: '10:00 AM', kind: 'approval' },
  { id: 't2', title: 'Nisolo campaign launch', owner: 'Maya', due: '1:30 PM', kind: 'launch' },
  { id: 't3', title: 'Review Summer Occasion budget', owner: 'Orr', due: '4:00 PM', kind: 'review' },
]

export type RailProject = {
  id: string
  name: string
  progress: number
  lead: string
  nextStep: string
}

export const railProjects: RailProject[] = [
  { id: 'p1', name: 'Summer Occasion Edit', progress: 78, lead: 'Carolyn', nextStep: 'Creative approval' },
  { id: 'p2', name: 'Everyday Surprise Box', progress: 52, lead: 'Orr', nextStep: 'Channel allocation' },
  { id: 'p3', name: 'Nisolo Footwear', progress: 31, lead: 'Maya', nextStep: 'Ad studio drafts' },
  { id: 'p4', name: '1 People Outerwear', progress: 14, lead: 'Maya', nextStep: 'Opportunity review' },
]

export type TrendPoint = {
  month: string
  revenue: number
  spend: number
  units: number
}

export const demandTrend: TrendPoint[] = [
  { month: 'Mar', revenue: 96400, spend: 26800, units: 962 },
  { month: 'Apr', revenue: 118200, spend: 31200, units: 1148 },
  { month: 'May', revenue: 134900, spend: 33400, units: 1290 },
  { month: 'Jun', revenue: 152600, spend: 38100, units: 1476 },
  { month: 'Jul', revenue: 169300, spend: 41500, units: 1618 },
  { month: 'Aug', revenue: 184920, spend: 44100, units: 1842 },
]

export type SocialSnapshotStat = {
  label: string
  value: string
  detail: string
}

export const socialSnapshot: SocialSnapshotStat[] = [
  { label: 'Follower growth', value: '+12.4K', detail: 'Last 30 days across Instagram and TikTok' },
  { label: 'Organic traffic', value: '38,600', detail: 'Sessions driven to recovery listings' },
  { label: 'Best performing', value: '9.1%', detail: 'TikTok — "What makes a pair a second?"' },
]
